import { render, staticRenderFns } from "./ArchiveRoot.vue?vue&type=template&id=1373286b&"
import script from "./ArchiveRoot.vue?vue&type=script&lang=js&"
export * from "./ArchiveRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports